import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-12">
          热度榜单
        </h2>
        <div className="flex flex-col gap-3">
          {rankingData.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              className="flex items-center gap-5 p-5 bg-background-50 rounded-2xl hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span
                className={`text-3xl md:text-4xl font-heading font-bold w-12 text-center ${
                  item.id <= 3 ? 'text-accent-500' : 'text-foreground-300'
                }`}
              >
                {String(item.id).padStart(2, '0')}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-xs text-foreground-400">{item.views}</span>
                <span
                  className={`px-2.5 py-1 text-xs font-medium rounded-full ${
                    item.hot === '爆'
                      ? 'bg-primary-500 text-white'
                      : item.hot === '热'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  {item.hot}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}